export default __webpack_public_path__ + "static/media/worldss.3b51cfcc.png";